import { gql } from "@apollo/client";

export default gql`
    mutation update_worksheet_sync_block_map(
        $object: worksheet_sync_block_map_insert_input!
    ) {
        insert_worksheet_sync_block_map_one(
            object: $object
            on_conflict: {
                constraint: sync_block_map_master_block_id_key
                update_columns: [sync_block_ids]
            }
        ) {
            id
        }
    }
`;
